import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import moment from "moment-timezone";
import "moment/min/locales";
import i18n from "i18n";

import { DEFAULT_LANGUAGE } from "../../constants";

import { Theme, Lang } from "../../redux/services/config";

import styles from "./Header.module.scss";

export const headerDataQa = "header";

interface Props {
  time: string;
  timezone: string;
  theme: Theme;
  lang: Lang;
  icon?: {
    svg_base64: string;
  };
}

const Header: React.FC<Props> = ({ time, timezone, theme, lang, icon }) => {
  const clientTime = useRef(new Date().getTime());
  const [serverTime, setServerTime] = useState(new Date(time).getTime());

  const currentLanguage = i18n.language;
  const heading =
    lang[currentLanguage]?.heading || lang[DEFAULT_LANGUAGE]?.heading;
  const subheading =
    lang[currentLanguage]?.subheading || lang[DEFAULT_LANGUAGE]?.subheading;
  const timeFormat =
    lang[currentLanguage]?.time_format || lang[DEFAULT_LANGUAGE]?.time_format;

  // Increment time using the server's time as a baseline starting point
  useEffect(() => {
    setTimeout(() => {
      const currentMilliseconds = new Date().getTime();
      const difference = currentMilliseconds - clientTime.current;
      setServerTime(serverTime + difference);
      clientTime.current = currentMilliseconds;
    }, 1000);
  }, [serverTime]);

  return (
    <div
      data-qa={headerDataQa}
      className={styles.container}
      style={{
        backgroundColor: theme.background_color,
        fontFamily: theme.font_family,
        color: theme.text_color,
      }}
    >
      <div
        className={classNames({
          [styles.withIcon]: icon?.svg_base64,
        })}
      >
        {icon && (
          <img
            data-qa="title-image"
            src={`data:image/svg+xml;base64,${icon.svg_base64}`}
            alt="Header icon"
            className={styles.icon}
          />
        )}
        <div>
          <h1 data-qa="title" className={styles.heading}>
            {heading}
          </h1>
          <h2 data-qa="sub-title" className={styles.subheading}>
            {subheading}
          </h2>
        </div>
      </div>
      {timeFormat && (
        <p data-qa="time" className={styles.time}>
          {moment(serverTime)
            .tz(timezone)
            .locale(
              lang[currentLanguage]?.time_format
                ? currentLanguage
                : DEFAULT_LANGUAGE,
            )
            .format(timeFormat)}
        </p>
      )}
    </div>
  );
};

export default Header;
